module.exports = __webpack_public_path__ + "md.ebd1e8958f542de78c65.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/md.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/md.svg
// module chunks = styles